<template>
	<section class="deal-checklist-doc-upload">
		<LoaderComponent v-show="isLoading"></LoaderComponent>

		<div
			v-show="!isLoading && showStartScreen"
			class="start-screen"
		>
			<div class="upload-area">
				<h1>{{ checklistItem.name }}</h1>
				<p>{{ checklistItem.description }}</p>

				<InputFile
					:showFilePreview="true"
					:filesAccepted="mimeDocType"
					:usingTouchScreen="true"
					capture="environment"
					@fileDataChange="onFileDataChange"
				/>
			</div>

			<button
				class="button submit-button"
				@click="onSubmitFile"
				:disabled="!canSubmitFile"
			>
				Submit
			</button>
		</div>

		<div
			v-show="!isLoading && showSuccessScreen"
			class="success-screen"
		>
			<h2>
				Your document was successfully uploaded.
				<br />
				<i class="fas fa-check" />
			</h2>

			<button
				class="button return-button"
				@click="$emit('exitItem')"
			>
				Return to Checklist
			</button>
		</div>
	</section>
</template>

<script>
	import api from '@core/services/api/_api';
	import { DocAssociation } from '@core/classes/SharedEnums';
	import ENUMS from '@core/classes/Enums';
	import InputFile from '@core/components/InputFile.vue';
	import LoaderComponent from '@core/components/UI/LoaderComponent.vue';

	export default {
		name: 'CustomerChecklistDocUpload',
		emits: ['uploadComplete', 'exitItem', 'error'],
		props: {
			dealId: String,
			checklistItem: Object,
		},
		data() {
			return {
				isLoading: false,
				showStartScreen: true,
				showSuccessScreen: false,
				fileData: null,
			};
		},
		computed: {
			isPhotoUpload() {
				return this.checklistItem.type === ENUMS.DealChecklistType.Upload_Image;
			},
			isFileUpload() {
				return this.checklistItem.type === ENUMS.DealChecklistType.Upload_File;
			},
			mimeDocType() {
				//TODO: should be based off of itemType
				if (this.isPhotoUpload) return 'image/*';
				return 'application/pdf, image/*, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document';
			},
			canSubmitFile() {
				return !!this.fileData;
			},
		},
		mounted() {
			const fileInputButtons = document.querySelector('.input-file > .upload-buttons');
			if (fileInputButtons) fileInputButtons.classList.add('button-slant-split');
		},
		methods: {
			openSuccessScreen() {
				this.showStartScreen = false;
				this.showSuccessScreen = true;
				this.$emit('uploadComplete');
			},
			onFileDataChange(fileData) {
				this.fileData = fileData;
			},
			async onSubmitFile() {
				this.isLoading = true;

				const documentForm = new FormData();
				documentForm.append('fileData', this.fileData);

				const docName = this.fileData.name.replace(/[^\w.\-~]/g, '-');

				const docInfo = {
					fileName: docName,
					fileType: this.fileData.type,
					docType: this.checklistItem.subtype,
					source: 'CUSTOMER UPLOAD',
				};

				documentForm.append('associations', JSON.stringify(this.checklistItem.associations));
				documentForm.append('docInfo', JSON.stringify(docInfo));

				// This page isn't really in use anymore. Just putting placeholders here for now so things don't break.
				documentForm.append('createdBy', JSON.stringify('Customer Checklist Portal'));
				documentForm.append('creatorType', JSON.stringify(DocAssociation.Customer));

				const response = await api.documents.upsertDocument(documentForm);
				if (!response || !response.data) {
					console.error('Encountered server error when trying to upload file.');
					this.$emit('error', 'Encountered server error when trying to upload file.');
				} else this.openSuccessScreen();

				this.isLoading = false;
			},
		},
		components: {
			LoaderComponent,
			InputFile,
		},
	};
</script>
<style>
	.deal-checklist-doc-upload {
		display: flex;
		flex-grow: 1;
	}

	.deal-checklist-doc-upload .submit-button,
	.deal-checklist-doc-upload .return-button {
		width: 100%;
		font-weight: bold;
		font-size: 2em;
		padding: 10px;
		background-color: var(--success-button-color);
		color: var(--alt-text-color);
		transition: all 0.3s;
	}

	.deal-checklist-doc-upload .start-screen,
	.deal-checklist-doc-upload .success-screen {
		display: flex;
		flex-grow: 1;
		flex-direction: column;
		justify-content: space-between;
	}

	.deal-checklist-doc-upload .start-screen > .upload-area {
		margin-bottom: 40px;
	}

	.deal-checklist-doc-upload .success-screen > h2 {
		text-align: center;
	}

	.deal-checklist-doc-upload .success-screen > h2 > i.fa-check {
		margin: 10px;
		font-size: 100px;
		color: var(--success-button-color);
	}

	.deal-checklist-doc-upload .success-screen > .return-button {
		background-color: var(--accept-color);
	}

	.deal-checklist-doc-upload .input-file {
		margin: 15px 10px;
	}

	.deal-checklist-doc-upload .input-file .upload-buttons {
		margin-top: 10px;
	}

	.deal-checklist-doc-upload .input-file label {
		padding: 10px;
		font-weight: bold;
		border-radius: 10px;
	}

	.deal-checklist-doc-upload .input-file label span {
		font-size: 20px;
	}

	.deal-checklist-doc-upload .input-file .button-slant-split > label:first-child:last-child span {
		left: 50% !important;
	}

	.deal-checklist-doc-upload .input-file .button-slant-split > label:first-child span {
		left: 45%;
	}

	.deal-checklist-doc-upload .input-file .button-slant-split > label:last-child span {
		left: 55%;
	}
</style>
